import { combineEpics } from "redux-observable";
import "./views/Create/epics/epics.js";
import { rootEpic as rootEpic$1 } from "./views/Create/components/HypothesisCreateContainer/Create.epics.js";
const rootEpic = combineEpics(rootEpic$1);
export {
  rootEpic
};
//# sourceMappingURL=epics.js.map
